import { getPrivateApi } from "../lib/axiosConfig";
import { FraudBlock, Page } from "../types/fraud.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/admin/fraud/blocks";

export const getFraudBlocks = async (
  page = 0,
  size = 10,
  search?: string
): Promise<Page<FraudBlock>> => {
  try {
    const params: Record<string, string | number> = { page, size };

    if (search?.trim()) params.search = search.trim();

    const { data } = await api.get(`${endpoint}`, { params });

    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar usuários bloqueados";

    console.error(errMsg, error?.response ?? error);

    const message = error?.response?.data?.message ?? errMsg;

    throw new AppError(message, error.status);
  }
};

export const unblockFraud = async (cpf: string, notes: string): Promise<string> => {
  try {
    await api.patch(`${endpoint}/${cpf}/unblock`, { notes });

    return cpf;
  } catch (error: any) {
    const errMsg = "Erro ao desbloquear CPF";

    console.error(errMsg, error?.response ?? error);

    const message = error?.response?.data?.message ?? errMsg;

    throw new AppError(message, error.status);
  }
};
